/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  Message, Popover, PopoverProps, Spacing, Stack, Text,
} from '@doveit/bricks';
import PopoverPreview from '../../../components/popover-preview/PopoverPreview';
import { Task } from '../../../providers/api/dtos';
import PopoverPreviewSkeleton from '../../../components/popover-preview/PopoverPreview.skeleton';
import * as styles from './ViewTaskPopoverPreview.style';
import TaskAvatar from '../../components/task-avatar/TaskAvatar';
import TaskPriorityBadge from '../../components/task-priority-badge/TaskPriorityBadge';
import { goToDetailPage } from '../../../utils/navigate/utils';
import { ReferenceType } from '../../../domain/types';
import useTask from '../../hooks/use-task/useTask';

interface BaseViewTaskPopoverPreviewProps extends React.AriaAttributes {
  trigger: PopoverProps['trigger'],
}

export type ViewTaskPopoverPreviewProps = BaseViewTaskPopoverPreviewProps & ({
  taskId: NonNullable<Task['id']>,
  task?: undefined,
} | {
  task: Task,
  taskId?: undefined,
});

export const LOAD_TASK_DATA_ERROR_MESSAGE = 'Non è stato possibile caricare le informazioni dell\'attività.';

const ViewTaskPopoverPreview: React.FC<ViewTaskPopoverPreviewProps> = ({
  taskId,
  task: externalTask,
  trigger,
  ...rest
}) => {
  const { data: loadedTask, isLoading: isTaskLoading, error: taskError } = useTask(taskId);
  const task = externalTask || loadedTask;

  const goToTaskPage = React.useCallback(() => {
    goToDetailPage(task!.id!, ReferenceType.TASK);
  }, [task]);

  return (
    <Popover
      trigger={trigger}
      hasArrow
      {...rest}
    >
      <div css={styles.wrapper}>
        {(isTaskLoading && !taskError) && (
          <PopoverPreviewSkeleton aria-label="Caricamento informazioni attività in corso" />
        )}
        {(taskError) && (
          <Spacing padding={200}>
            <Message
              type="critical"
              message={LOAD_TASK_DATA_ERROR_MESSAGE}
            />
          </Spacing>
        )}
        {task && (
          <PopoverPreview
            aria-label="Informazioni attività"
            title={task.title}
            avatar={(
              <TaskAvatar size="L" />
            )}
            action={{
              label: 'Visualizza attività',
              'aria-label': 'Pulsante per visualizzare i dettagli dell\'attività',
              onClick: goToTaskPage,
            }}
          >
            <Stack gap={150}>
              <div>
                <TaskPriorityBadge task={task} />
              </div>
              {task.description && (
                <Text.BodySmall>
                  {task.description}
                </Text.BodySmall>
              )}
            </Stack>
          </PopoverPreview>
        )}
      </div>
    </Popover>
  );
};

export default ViewTaskPopoverPreview;
